import { WEB_DESKTOP_RALALI_URL } from 'common/constants'

export default {
  data: {
    home: [
      {
        alert_id: 1,
        alert_key: 'scam-fraud-alert',
        configuration: {
          content_length: 200,
          end_date: {
            seconds: 1798675200,
          },
          start_date: {
            seconds: 1698771600,
          },
          visibility: 'once_per_day',
        },
        content:
          'Waspada Penipuan! Pastikan transaksi hanya di Ralali.com atau hubungi WA 0818-500-465.',
        is_active: true,
        order_key: 1,
        title: 'Waspada Penipuan',
        type: 'information',
      },
      {
        alert_id: 2,
        alert_key: 'wallet-maintenance',
        configuration: {
          content_length: 200,
          end_date: {
            seconds: 1675638000,
          },
          start_date: {
            seconds: 1675418400,
          },
          visibility: 'once_per_day',
        },
        content:
          'Wallet akan menjalani pemeliharaan untuk penyempurnaan sistem pada tanggal 3 Feb 2023 18:00 WIB hingga 6 Feb 2023 06:00 WIB',
        is_active: false,
        order_key: 1,
        title: 'Wallet dalam pemeliharaan',
        type: 'information',
      },
      {
        alert_id: 3,
        alert_key: 'courier-maintenance',
        configuration: {
          content_length: 200,
          end_date: {
            seconds: 1707066000,
          },
          start_date: {
            seconds: 1704362400,
          },
          visibility: 'once_per_day',
          target: 'seller',
        },
        content:
          'Layanan kurir pengiriman dari pihak ketiga (3PL) kini sudah beroperasi kembali. Mohon atur kembali pengaturan pengiriman di toko Anda untuk memastikan pembeli dapat melakukan proses checkout dengan menggunakan kurir pengiriman yang tersedia.',
        is_active: true,
        order_key: 2,
        title: 'Kurir Pengiriman Kembali Beroperasi',
        type: 'information',
        redirect: {
          is_active: true,
          title: 'Atur Pengiriman',
          url: `${WEB_DESKTOP_RALALI_URL}/seller/setting/shipping`,
        },
      },
    ],
  },
}
